/** @format */
import axios, { type AxiosResponse } from 'axios';

import { AxiosValidationError } from './types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Legacy code: do not use as an example.
export const isAxiosResponse = (response: any): response is AxiosResponse =>
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Legacy code: do not use as an example.
    Boolean(response.data);

export const isAxiosValidationError = (
    error: unknown
): error is AxiosValidationError => {
    return (
        axios.isAxiosError(error) &&
        'validationErrors' in error &&
        error.validationErrors !== null &&
        typeof error.validationErrors === 'object'
    );
};
